import React from 'react';

const BANNER_NAME = ( {name, discount, link} ) => {
  return (
    <div className='banner_content' >
      <h3>{name}</h3>
      <p> Get free discount for every <span>${discount} </span>purchase </p>
      <a href={link}>Read more</a>
    </div>
  )
};

export default BANNER_NAME;
